onComplete(function() {
	if(document.querySelector('.nav-tabs')) {
		let activeButton = 	document.querySelector('.nav-tabs button.active');
		document.querySelectorAll('.nav-tabs button').forEach(button => {
			button.addEventListener('click', () => {
				let transform = button.getBoundingClientRect().y - activeButton.getBoundingClientRect().y
				document.querySelector('.nav-tabs-indicator').style.transform = "translate(-50%," + transform + "px)";
			})
		});
	}

	if(document.querySelector('.fit-view')) {
		const colors = ['#FFB500', '#253086'];
		document.querySelectorAll('.fit-view .content-item-preview').forEach(preview => {
			preview.addEventListener('mouseover', () => {
				const random = Math.floor(Math.random() * colors.length);
				preview.querySelector('.image').style.borderColor = colors[random];
			})
		})
	}

	document.querySelector('header .navbar-toggler').addEventListener('click', () => {
		if(document.querySelector('.nav-header').classList.contains('open')) {
			gsap.to('.navbar-overlay .nav-title', {
				y: 32,
				opacity: 0
			});
			document.querySelector('.nav-header').classList.remove('open')
		} else {
			gsap.to('.navbar-overlay .nav-title', {
				y: 0,
				opacity: 1,
				stagger: .05,
				duration: .25,
				ease: "power2.out",
				delay: 0.15
			});
			document.querySelector('.nav-header').classList.add('open')
		}
	})

	if(document.querySelector('.video-header video')) {
		document.querySelector('.sound-toggle').addEventListener('click', () => {
			if (document.querySelector('.sound-toggle').classList.contains('muted')) {
				document.querySelector('.video-header video').muted = false;
				document.querySelector('.sound-toggle').classList.remove('muted');
			} else {
				document.querySelector('.video-header video').muted = true;
				document.querySelector('.sound-toggle').classList.add('muted');
			}
		})
	}
});